import { useState,  useEffect, createRef } from 'react';
import logo from '../img/elizak_p.png'
import emptyImg from '../img/empty_image.png'
import Config from '../Config';

import ImageZoom from './ImageZoom';

import ZmienTermin from './ZmienTermin';
import Odwolanie from './Odwolanie';
 
 

import { WebRTCConfiguration } from 'wowza-webrtc-client'
import { WebRTCPublisher as Publisher } from 'wowza-webrtc-client-react'
import { WebRTCPlayer as Player } from 'wowza-webrtc-client-react'

function Prezentacja(props)
{

    
    const [det, setDet] = useState(null);

    const [notatka_publiczna, setNotatkaPubliczna] = useState(""); 
    const [b64, setB64] = useState("");

    const [elizak_stream, setElizakStream] = useState('');
    const [klient_stream, setKlientStream] = useState('');
    const [isPublish, setIsPublish] = useState(false);

    const [elizakConnect, setElizakConnect] = useState(0);

    
    const [video_status, setVideoStatus] = useState(null);
    
    const [mousePos, setMousePos] = useState({});






    ///--------------------------


    const wowza_config =  {
        WEBRTC_SDP_URL: 'wss://5e8e601fcea9e.streamlock.net:444/webrtc-session.json',      
        WEBRTC_APPLICATION_NAME: 'elizakstream',
        WEBRTC_FRAME_RATE: 29,
        WEBRTC_AUDIO_BIT_RATE: 64,
        WEBRTC_VIDEO_BIT_RATE: 360,
      }


    const ref_publisher =  createRef();
    const ref_player =  createRef();


    const goPublish = (e) => {
    
        //testWSS(); 
        e.target.innerHTML = "Czekaj...";
        ref_publisher.current.publish(klient_stream);        
    }

    const goStopPublish = (e) => {
        e.target.innerHTML = "Czekaj...";
        ref_publisher.current.disconnect();
    }

    const getStatusPublish = (status)  => {
            console.log('Zmiana statusu publikowanego obrazu', status)

            if(status.isPublishing)  console.log('Trwa publikowanie');
            if(!status.isPublishing)  console.log('Publikowanie zakończone');
            setIsPublish( status.isPublishing );
            
    }



  
   

    const goPlay = () => {                       
         ref_player.current.play(); //uruchom z opoznieniem.. strumien potrzebuje czasu na start..           
    }

    const goStopPlaying = () => {
        ref_player.current.stop();
    }

    const testWSS = () => {

        try
        {
            //var wsConnection = new WebSocket(wowza_config.WEBRTC_SDP_URL, 'echo-protocol' );
            var wsConnection = new WebSocket(wowza_config.WEBRTC_SDP_URL  );

            wsConnection.onopen = function () {
                console.log("wss opened! ");                
            }
            wsConnection.onmessage = function (evt) {
                console.log(" onmessage: " + evt.data);
            }       
        }
        catch(e)
        {
          console.log("ERROR X: " + e);
          return;
        }
      

    }
    //-------------------------------


 


    const onMouseImage = (e ) => {            

        /*
        let bounds = e.target.getBoundingClientRect();
        let viewWidth = document.documentElement.clientWidth;
        let viewHeight = document.documentElement.clientHeight;

        var xCursorPosition = e.clientX;
        var yCursorPosition = e.clientY;

        console.log("EE " + viewWidth + " | " + viewHeight)
        console.log("Cur " + xCursorPosition + " | " + yCursorPosition + " ||  " + e.pageX + " " + e.pageY);
        */
}



const refreshVideo = () => {
        
    var publishStatus = '0';
    if(isPublish) publishStatus = '1';

        var dt = {   
            id: props.id,             
            klient_stream_status: publishStatus 
        }

        fetch( Config.url + '/rest_public,video_refresh', {
            method: 'POST', 
            body: JSON.stringify(dt), 
            headers: {
                'Content-Type': 'text/html',
                'X-API-KEY': props.apiKey
            }
         })
         .then(res => res.json() )
         .then(res => {                       
          
            console.log( JSON.stringify(res) );

            if(res.t0_aktywne == 2 && elizakConnect == 1)
            {
                document.location.href = "/";
            }

            if(res.t0_elizak_stream_status == '1' && ((video_status  != null && video_status.t0_elizak_stream_status != res.t0_elizak_stream_status) || video_status == null) ) //elizak nadaje.
            {
           
                    goPlay();
        
    
            }

            if(res.t0_elizak_stream_status == '0' && ((video_status  != null && video_status.t0_elizak_stream_status != res.t0_elizak_stream_status) || video_status == null) ) //klient nadaje..
            {
                goStopPlaying();
            }

            if(res.t0_plik_widoczny.length > 0)
            {
                if( (video_status != null && res.t0_plik_widoczny != video_status.t0_plik_widoczny) || video_status == null )
                {
                        getB64(res.t0_plik_widoczny)                        
                }                
            }else
            {                 
                setB64("");
            }

            if( res != null && res.sec_ago < 5)
            {
                setElizakConnect(1);
            }

            setNotatkaPubliczna(res.t0_public_txt);
            setVideoStatus(res);                

         } )
         .catch(err => {
            console.log("ErrXH " + err);
         });
                   

         return false;



}


const zmienGodzine = () => {

}


const odwolaj = () => {
    
}


useEffect( ()=>{
  //  updateData();


    const interval = setInterval(() => {
        refreshVideo();
      }, 3000);
      return () => clearInterval(interval);


} );


const getB64 = (fn) => {
        
    var dt = {   
        file_name: fn   
    }

    fetch( Config.url + '/rest_public,video_file_b64', {
        method: 'POST', 
        body: JSON.stringify(dt), 
        headers: {
            'Content-Type': 'text/html',
            'X-API-KEY': props.apiKey
        }
     })
     .then(res => res.json() )
     .then(res => {                       
        
          if(res.status == 'OK')
          {
            setB64( res.b64 );
          }

     } )
     .catch(err => {
        console.log("Errxx " + err);
     });
               

     return false;
}

const sendData = () => {
        
    var dt = {   
        id: props.id         
    }

    fetch( Config.url + '/rest_public,video_det', {
        method: 'POST', 
        body: JSON.stringify(dt), 
        headers: {
            'Content-Type': 'text/html',
            'X-API-KEY': props.apiKey
        }
     })
     .then(res => res.json() )
     .then(res => {                       
        setDet(res);
 
        setNotatkaPubliczna( res.det.t0_public_txt);

        if(elizak_stream != res.det.t0_elizak_stream)
        {
            setElizakStream(res.det.t0_elizak_stream);
        }

        if(klient_stream != res.det.t0_klient_stream)
        {
            setKlientStream(res.det.t0_klient_stream);
        }

     } )
     .catch(err => {
        console.log("Err " + err);
     });
               

     return false;
}


const onDateChange = (dt) => {
    document.location.href = "/";
}


    if(det == null)
    {
        sendData();
        return (
            <span>Czekaj...</span>
        )
    }

    var readyB64 = null;
    var rawB64 = '';

    if(b64.length < 20)
    {
        readyB64 = <img src={ emptyImg}   />
        rawB64 = emptyImg;
    }else
    {
        readyB64 = <img src={ "data:image/jpeg;base64, "+  b64 }  onMouseMove={onMouseImage} />
        rawB64 = "data:image/jpeg;base64, "+  b64 
    }


    var msgInfo = 'Aktualnie nie udostępniasz obrazu';
    var bcolor = 'blockFilterRed';       
    var btnPublish = (
            <span className='btn' onClick={goPublish}>Publikuj obraz</span>
    )
    if(isPublish)
    {
        var btnPublish = (
            <span className='btn' onClick={goStopPublish}>Zatrzymaj</span>
        )

        msgInfo = 'Publikacja obrazu aktywna, jesteś na żywo';
        bcolor = 'blockFilterGreen';
    }

    
    var msgInfoKl = 'Oczekuje na połączenie video z konsultantem';
    var bcolorKl = 'blockFilterRed';       

    if( video_status != null && video_status.t0_elizak_stream_status == '1')
    {
        msgInfoKl = 'Konsultant rozpoczął nadawanie obrazu';
        bcolorKl = 'blockFilterGreen';
    }


    var msgInfoKlA = 'Oczekiwanie na konsultanta....';      

    if( video_status != null && video_status.sec_ago < 5)
    {
        msgInfoKlA = 'Konsultant aktywny';        
    }




    return (
        <div className='panel_prezentacji'>

        

             <div className='left_site'>            
                  
             <img src={logo} className="img_logo" />

            <div>[ {det.det.t0_data_rozpoczecia} ]</div>
            <br/>
             <div>
                <ZmienTermin id={det.det.t0_id} def={det.det.t0_data_rozpoczecia} onDateChange={onDateChange} />
                &nbsp;
                <Odwolanie id={det.det.t0_id} def={det.det.t0_data_rozpoczecia} onDateChange={onDateChange} />
             </div>
          

                <div className='el_cam'>                                                                                     
                    <Publisher id="publisher-test"
                        ref={ref_publisher}
                        className="d-block"
                        streamName={klient_stream}                                                                       
                        style={{ width: '100%', height: '100%'}}
                        config={ wowza_config }
                        onVideoStateChanged={(state) => {                                        
                            getStatusPublish(state);
                        }}
                        />     
                        <br/>                                                              
                    {btnPublish}
                </div>


       
               

                <div className='el_cam'>                                                                                     
                    <Player
                        id="player-test"
                        ref={ref_player}
                        className="d-block"
                        streamName={elizak_stream}
                        style={{ width: '100%', height: '100%'}}
                        rotate="none"   // 'cw'|'none'|'ccw'
                        config={ wowza_config }
                        autoPlay={false}
                        onPlayerStateChanged={(status) => {
                            console.log('Player state has changed', status)
                        }}/>                               
                </div>


             </div>

             <div className='center_site'>

            <div>
                    <b> {msgInfoKlA} </b>
            </div>

             <div>                                     
                    <table className='tabx'>
                        <tr>                        
                            <td>
                                <div className={" msgBlock " + bcolor}>
                                    {msgInfo}
                                </div>
                            </td>
                           

                            <td>
                                <div className={" msgBlock " + bcolorKl}>
                                    {msgInfoKl}
                                </div>
                            </td>
                        </tr>
                    </table>
            </div>

                         <div className='el_screen'>

                            <div className='notatka'>{notatka_publiczna}</div>
                                
                                    <div className='el_screen_main'>
                                        {readyB64}
                                    </div>

                                    <div><ImageZoom b64={rawB64} /> </div>
     
                                    <br/><br/>

                                     

                                

                            </div>


             </div>

        </div>
    )
}


export default Prezentacja;